import { createRouter, createWebHistory } from 'vue-router'
// import { wexinShare } from '../utils/wexinShare.js'
// import { getWeChatAutograph } from '@/api/common'
import Home from '../components/HomePage.vue'
import About from '../components/AboutPage.vue'
import Login from '../components/LoginPage.vue'
import Register from '../components/RegisterPage.vue'
import My from '../components/MyPage.vue'
import HomeDetail from '../components/HomeDetailPage.vue'
import AllTeachType from '../components/AllTeachTypePage.vue'
import Search from '../components/SearchPage.vue'
import Person from '../components/PersonPage.vue'
import ResetPhone from '../components/ResetPhone.vue'
import TeachDetail from '../components/TeachDetailPage.vue'
import MyOrder from '../components/MyOrderPage.vue'
import PaidTeach from '../components/PaidTeachPage.vue'
import Cashback from '../components/CashbackPage.vue'
import OrderPay from '../components/OrderPayPage.vue'
import ExamDetail from '../components/ExamDetailPage.vue'
import ExamWork from '../components/ExamWorkPage.vue'
import BindBank from '../components/BindBankPage.vue'
import ApplyCashback from '../components/ApplyCashbackPage.vue'
import CashbackDescribe from '../components/CashbackDescribePage.vue'
import CashbackRecord from '../components/CashbackRecordPage.vue'

const routes = [
  {
    path: '/:id',
    name: 'home',
    component: Home
  },
  {
    path: '/home/:id',
    name: 'home',
    props: true,
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/login/:id',
    name: 'login',
    component: Login,
    props: true,
    meta: { title: '登录' } // 添加meta字段，定义标题
  },
  {
    path: '/register/:id',
    name: 'register',
    component: Register,
    props: true,
    meta: { title: '注册' } // 添加meta字段，定义标题
  },
  {
    path: '/my',
    name: 'my',
    component: My,
    props: true,
    meta: { title: '我的' } // 添加meta字段，定义标题
  },
  {
    path: '/homeDetail',
    name: 'homeDetail',
    component: HomeDetail,
    props: true,
    meta: { title: '首页' } // 添加meta字段，定义标题
  },
  {
    path: '/allTeachType',
    name: 'allTeachType',
    component: AllTeachType,
    props: true,
    meta: { title: '更多分类' } // 添加meta字段，定义标题
  },
  {
    path: '/search',
    name: 'search',
    component: Search,
    props: true,
    meta: { title: '搜索' } // 添加meta字段，定义标题
  },
  {
    path: '/person/:id',
    name: 'person',
    component: Person,
    props: true,
    meta: { title: '个人信息' } // 添加meta字段，定义标题
  },
  {
    path: '/resetPhone/:id',
    name: 'resetPhone',
    component: ResetPhone,
    props: true,
    meta: { title: '修改手机号' } // 添加meta字段，定义标题
  },
  {
    path: '/teaching/:id',
    name: 'teaching',
    component: TeachDetail,
    props: true,
    meta: { title: '课程查看' } // 添加meta字段，定义标题
  },
  {
    path: '/myOrder/:id',
    name: 'myOrder',
    component: MyOrder,
    props: true,
    meta: { title: '我的订单' } // 添加meta字段，定义标题
  },
  {
    path: '/paidTeach/:id',
    name: 'paidTeach',
    component: PaidTeach,
    props: true,
    meta: { title: '已购课程' } // 添加meta字段，定义标题
  },
  {
    path: '/cashback/:id',
    name: 'cashback',
    component: Cashback,
    props: true,
    meta: { title: '分销收益' } // 添加meta字段，定义标题
  },
  {
    path: '/orderPay/:id',
    name: 'orderPay',
    component: OrderPay,
    props: true,
    meta: { title: '订单支付' } // 添加meta字段，定义标题
  },
  {
    path: '/examDetail/:id',
    name: 'examDetail',
    component: ExamDetail,
    props: true,
    meta: { title: '测试' } // 添加meta字段，定义标题
  },
  {
    path: '/examWork/:id',
    name: 'examWork',
    component: ExamWork,
    props: true,
    meta: { title: '考核' } // 添加meta字段，定义标题
  },
  {
    path: '/bindBank/:id',
    name: 'bindBank',
    component: BindBank,
    props: true,
    meta: { title: '绑定银行卡' } // 添加meta字段，定义标题
  },
  {
    path: '/applyCashback/:id',
    name: 'applyCashback',
    component: ApplyCashback,
    props: true,
    meta: { title: '申请提现' } // 添加meta字段，定义标题
  },
  {
    path: '/cashbackDescribe/:id',
    name: 'cashbackDescribe',
    component: CashbackDescribe,
    props: true,
    meta: { title: '提现说明' } // 添加meta字段，定义标题
  },
  {
    path: '/cashbackRecord/:id',
    name: 'cashbackRecord',
    component: CashbackRecord,
    props: true,
    meta: { title: '提现记录' } // 添加meta字段，定义标题
  },
  
  
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// import { showToast } from 'vant'
//注册一个全局前置守卫,确保要调用 next 方法，否则钩子就不会被 resolved
router.beforeEach((to, from, next) => {
  // 存储分享ID
  if (to.query !== undefined && to.query.memberId) {
    sessionStorage.setItem('sourceStudentId', to.query.memberId)
  }
  //通过正则表达式匹配broser 中是否含有MicroMessenger字符串
  var broser = window.navigator.userAgent.toLowerCase();
  //判断该页面有channel
  let isHome = to.name === 'home' && to.query.value === undefined;
  if (broser.match(/MicroMessenger/i) == 'micromessenger' && (isHome || to.name === 'teaching')) {
    let authUrl = sessionStorage.getItem("iOS-URL") || null;
    //准备一个跳转的query对象
    let query = to.query
    if (authUrl !== null) {
      sessionStorage.removeItem("iOS-URL");
      // next(false)
      if (isHome) {
        var protocol = window.location.protocol;
        var hostname = window.location.hostname;
        var port = window.location.port ? ':' + window.location.port : '';//如果端口号不是默认,则添加':'和端口号
        var baseUrl = protocol + '//' + hostname + port;
        // showToast(baseUrl + to.path);
        window.location.href = baseUrl + to.path;
      }
      if (to.name === 'teaching') {
        window.location.href = to.path + '?teachingId=' + query.teachingId;
      }
    } else if(to.query.memberId) {
      // next(false)
      if (isHome) {
        window.location.href = to.path;
      }
      if (to.name === 'teaching') {
        window.location.href = to.path + '?teachingId=' + query.teachingId;
      }
    } else {
      next()
    }
    // //路由切换时，如果没有就添加，有就跳过执行，添加固定参数
    // let active = localStorage.getItem('loginInfo') || null;
    // if (active != null && !to.query.memberId) {
    //   //准备一个跳转的query对象
    //   let query = to.query
    //   query.memberId = JSON.parse(active).id;
    //   if (authUrl !== null) {
    //     sessionStorage.removeItem("iOS-URL");
    //     if (isHome) {
    //       window.location.href = to.fullPath + '?memberId=' + query.memberId;
    //     }
    //     if (to.name === 'teaching') {
    //       window.location.href = to.fullPath + '?teachingId=' + query.teachingId + '&memberId=' + query.memberId;
    //     }
    //     next(false)
    //   } else {
    //     next({
    //       path: to.path,
    //       query: query
    //     })
    //   }
    // } else if (active != null) {
    //   if (authUrl !== null) {
    //     //准备一个跳转的query对象
    //     let query = to.query
    //     sessionStorage.removeItem("iOS-URL");
    //     if (isHome) {
    //       window.location.href = to.fullPath + '?teachingId=' + query.teachingId;
    //     }
    //     if (to.name === 'teaching') {
    //       window.location.href = to.fullPath + '?teachingId=' + query.teachingId;
    //     }
    //     next(false)
    //   } else {
    //     next()
    //   }
    // } else {
    //   if (authUrl !== null) {
    //     //准备一个跳转的query对象
    //     let query = to.query
    //     sessionStorage.removeItem("iOS-URL");
    //     if (isHome) {
    //       window.location.href = to.fullPath;
    //     }
    //     if (to.name === 'teaching') {
    //       window.location.href = to.fullPath + '?teachingId=' + query.teachingId;
    //     }
    //     next(false)
    //   } else {
    //     next()
    //   }
    // }
  } else {
    next()
  }
})

// router.afterEach((to) => {
  // 存储分享ID
  // if (to.query !== undefined && to.query.memberId) {
  //   sessionStorage.setItem('sourceStudentId', to.query.memberId)
  // }
  // //通过正则表达式匹配broser 中是否含有MicroMessenger字符串
  // var broser = window.navigator.userAgent.toLowerCase();
  // if (broser.match(/MicroMessenger/i) == 'micromessenger' && (to.name === 'home' || to.name === 'teaching')) {
  //   let path = window.location.href;
  //   showToast(path);
  //   let index = path.lastIndexOf("/");
  //   let merchantId = path.substring(index + 1, path.length);
  //   // let shareUrl = '';
  //   // let active = localStorage.getItem('loginInfo') || null;
  //   // if (active != null) {
  //   //   if (path.includes('?')) {
  //   //     shareUrl = path + '&memberId=' + JSON.parse(active).id;
  //   //   } else {
  //   //     shareUrl = path + '?memberId=' + JSON.parse(active).id
  //   //   }
  //   // } else {
  //   //   shareUrl = path;
  //   // }
  //   if (merchantId != null && merchantId != '') {
  //     let params = {
  //       merchantId: merchantId,
  //       shareUrl: path
  //     };
  //     getWeChatAutograph(params).then((res) => {
  //       if (res.code === 200) {
  //         res.link = path;
  //         wexinShare(res)
  //       }
  //     })
  //   }
  // }
// })

export default router